Ext.define('SA.view.locationsearch.LocationSearchField', {
    alias: 'widget.location-search-field',
    extend: 'SA.view.SearchField',

    allowCustomLocations: true,
    allowRecentListCustomLocationMenuItems: true,
    emptyText: 'Location Search',
    favoritesButtonTitle: 'Favorite Locations',
    recentButtonTitle: 'Recent Locations',

    recentList: {
        xtype: 'recent-locations-list',

        favorites: {
            source: SA.data.FavoriteLocations,
            title: 'Favorite Locations'
        },

        recent: {
            source: SA.data.RecentLocations,
            title: 'Recent Locations'
        },

        listeners: {
            'create:comboLocation': function(combo) {
                this.fireEvent('select', this, combo);
            },

            'create:radiusLocation': function(radiusLocation) {
                this.fireEvent('select', this, radiusLocation);
            },

            'edit:comboLocation': function(combo) {
                this.fireEvent('select', this, combo);
            }
        }
    },

    initComponent() {
        this.locationQueryManager = new SA.data.locationsearch.LocationQueryManager({
            geographicUnits: this.geographicUnits,

            scope: this,
            beforeQuery: this.beforeQuery,
            onResults: this.onLocationResults
        });

        this.addressQueryManager = new SA.data.locationsearch.AddressQueryManager({
            scope: this,
            beforeQuery: this.beforeQuery,
            onResults: this.onAddressResults,
            pageSize: 9 
        });

        this.recentList.allowCustomLocationMenuItems = this.allowRecentListCustomLocationMenuItems;

        this.callParent();

        this.locationsList = this.createLocationsList();

        this.rebuildFilter();
    },

    afterRender() {
        this.callParent();

        this.refreshInputTitle();
    },

    alignLocationsList() {
        var list = this.locationsList;

        if (!this.isExpanded) {
            return;
        }

        list.setWidth(this.getWidth());

        list.alignTo(this, 'tl-bl?', [0, 7]);
    },

    beforeQuery() {
        this.locationsList.showMask();
    },

    clearGeographicReleases() {
        this.locationQueryManager.clearGeographicReleases();

        this.recentList.clearGeographicReleases();
    },

    clearQueryCaches() {
        this.addressQueryManager.clearCache();
        this.locationQueryManager.clearCache();
    },

    createLocationsList() {
        return Ext.widget({
            pickerOwner: this,
            xtype: 'location-search-field-locations-list',

            listeners: {
                scope: this,
                'click:addressSearch': this.searchByAddress,
                select: this.onSelect
            }
        });
    },

    getAddressQueryParameters() {
        return {
            address: this.getValue(),
            geographicUnits: this.geographicUnits
        };
    },

    getChildItems() {
        return [this.locationsList, this.getRecentList(false)];
    },

    hideLocationsList() {
        var list = this.locationsList;

        if (!this.isExpanded) {
            return;
        }

        list.hide();

        this.isExpanded = false;

        this.mun(Ext.getDoc(), 'mousedown', this.onDocMouseDown, this);

        SA.LocationsReferenceTracker.purgeUnreferencedFromCache();

        this.fireEvent('results:hide');
    },

    initEvents() {
        this.callParent();

        this.mon(SA.data.LocationAliases, 'change', this.onAliasChange, this);
    },

    onAddressResults(response) {
        this.locationsList.setAddressLocations(response.results);
    },

    onAliasChange() {
        this.clearQueryCaches();
    },

    setCensusRelease(censusRelease) {
        this.addressQueryManager.setCensusRelease(censusRelease);
        this.addressQueryManager.clearCache();

        this.locationQueryManager.setCensusRelease(censusRelease);
        this.locationQueryManager.clearCache();

        this.recentList.setCensusRelease(censusRelease);
    },

    setGeographicReleases(geographicReleases) {
        geographicReleases = Ext.Array.from(geographicReleases);

        this.locationQueryManager.setGeographicReleases(geographicReleases);

        this.recentList.setGeographicReleases(geographicReleases);
    },

    onDestroy() {
        this.callParent();

        Ext.destroy(this.locationsList);
    },

    onDocMouseDown(ev) {
        if (!ev.within(this.el, false, true) && !ev.within(this.locationsList.el, false, true)) {
            this.hideLocationsList();
        }
    },

    onInputChange() {
        this.callParent();

        this.updatePickerVisibility();

        this.addressQueryManager.abort();
        this.locationQueryManager.setText(this.getValue());
    },

    onInputFocus() {
        this.callParent();

        this.updatePickerVisibility();
    },

    onLocationResults(response) {
        var me = this,
            results = response.results;

        if (!results.length && hasCachedAddressLocationsQuery()) {
            this.searchByAddress();
        }
        else {
            this.locationsList.setLocations(results);
        }

        function hasCachedAddressLocationsQuery() {
            var queryManager = me.addressQueryManager,
                params = me.getAddressQueryParameters(),
                query = queryManager.buildQuery(params);

            return queryManager.isCachedQuery(query);
        }
    },

    rebuildFilter() {
        if (!this.geographicUnits) {
            return;
        }

        var me = this,
            geographicUnits = this.geographicUnits,
            Locations = SA.data.LocationsCache;

        this.setFilter(location => isAllowed(location));

        function isAllowed(location) {
            if (Locations.isCustomLocation(location)) {
                if (!me.allowCustomLocations) {
                    return false;
                }

                var locations = Locations.get([].concat(location.locationSeries), me.refresh, me);

                return locations.every(isAllowed);
            }

            return location && geographicUnits.includes(location.geographicUnit);
        }
    },

    refreshInputTitle() {
        var units = this.geographicUnits;

        if (!this.rendered || !units) {
            return;
        }

        this.inputEl.set({title: getTitle()});

        function getTitle() {
            var unitNames = SA.data.GeographicUnits.get(units).map(singularName),
                country = SA.data.GeographicUnits.countryFor(units[0]),
                title = 'Search for a ' + unitNames.join(', ') + ', ';

            return title + (country === 'CAN' ? 'Address, or Postal Code' : 'or Address');
        }

        function singularName(unit) {
            return unit.singularName;
        }
    },

    searchByAddress() {
        var params = this.getAddressQueryParameters();

        this.addressQueryManager.setParameters(params);
    },

    setGeographicUnits(units) {
        if (typeof units === 'string') {
            units = [units];
        }

        this.geographicUnits = units;
        this.locationQueryManager.setGeographicUnits(units);
        this.rebuildFilter();
        this.refreshInputTitle();
    },

    showLocationsList() {
        var list = this.locationsList;

        if (this.isExpanded) {
            return;
        }

        this.isExpanded = true;

        list.show();

        this.alignLocationsList();

        this.mon(Ext.getDoc(), 'mousedown', this.onDocMouseDown, this);
        this.fireEvent('results:show');
    },

    setView(view) {
        var censusRelease = view.getCensusRelease(),
            units = view.getSupportedLocationGeoUnitIds();

        this.clearQueryCaches();

        this.setValue('');
        this.setCensusRelease(censusRelease);
        this.setGeographicUnits(units);

        this.getRecentList().setFilter(location => {
            return view.getType() !== 'project' && view.supportsLocation(location);
        });

        this.updateRecentVisibility();
    },

    updatePickerVisibility() {
        this[this.getValue().length < 3 ? 'hideLocationsList' : 'showLocationsList']();
    }
});
